/**
 * 主檔 entity `status` 中文標籤（非單據／工單／訂單 workflow、非庫存 invStatus）。
 */

export const ENTITY_STATUS_ACTIVE_INACTIVE_OPTIONS = [
  { value: 'ACTIVE', label: '啟用' },
  { value: 'INACTIVE', label: '停用' },
];

export const ENTITY_STATUS_FILTER_OPTIONS = [
  { value: 'DRAFT', label: '草稿' },
  ...ENTITY_STATUS_ACTIVE_INACTIVE_OPTIONS,
];

export function formatEntityStatusLabel(status) {
  if (status == null || status === '') {
    return '—';
  }
  const match = ENTITY_STATUS_FILTER_OPTIONS.find((option) => option.value === status);
  return match?.label ?? String(status);
}
